import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { getClient } from '@state/config';
import { Observable } from 'rxjs';
import { IClient } from 'rebus-models';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'terms-publicity',
  templateUrl: './terms-publicity.page.html',
  styleUrls: ['./terms-publicity.page.scss'],
})
export class TermsPublicityPage implements OnInit {

  public client$: Observable<IClient>;

  constructor(
    private store: Store<{}>,
    public modalCtrl: ModalController
  ) { }

  public ngOnInit() {
    this.client$ = this.store.select(getClient);
  }
}
